<template>
  <div class="empty-placeholder">
    <img src="../../assets/empty-requests.png" alt="Нет запросов" class="empty-image" />
    <h3 class="title">Нет запросов</h3>
    <p class="subtitle">
      Когда кто-то захочет начать с вами диалог,<br />
      его запрос появится здесь.
    </p>
  </div>
</template>

<script setup>
</script>

<style scoped>
.empty-placeholder {
  width: 100%;
  height: 100%;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px;
  text-align: center;
}

.empty-image {
  margin-top: -300px;
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-bottom: 20px;
}

.title {
  font-size: 18px;
  font-family: "Eastman-Bold", sans-serif;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.subtitle {
  font-size: 12px;
  font-family: "Eastman-Regular", sans-serif;
  color: #797979;
  line-height: 1.4;
}

@media (max-width: 430px) {

.empty-placeholder {
  min-height: calc(100vh - 180px);
  padding: 24px;
  justify-content: center;
}

.empty-image {
  width: 92px;
  height: 92px;
  margin-bottom: 18px;
  opacity: 0.95;
}

.title {
  font-size: 20px;
  margin-bottom: 10px;
  line-height: 1.1;
}

.subtitle {
  font-size: 14px;
  line-height: 1.5;
  max-width: 290px;
}

}

</style>